import { render, staticRenderFns } from "./LeftResult.vue?vue&type=template&id=2e12289c&scoped=true"
import script from "./LeftResult.vue?vue&type=script&lang=js"
export * from "./LeftResult.vue?vue&type=script&lang=js"
import style0 from "./LeftResult.vue?vue&type=style&index=0&id=2e12289c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e12289c",
  null
  
)

export default component.exports